import { DestroyRef, inject, Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { translate, TranslocoService } from '@jsverse/transloco';
import { selectTranslate } from '../i18n/portal-language.util';

@Injectable()
export class CustomMatDatepickerIntl extends MatDatepickerIntl {
    private readonly _destroyRef = inject(DestroyRef);
    private readonly _transloco = inject(TranslocoService);

    constructor() {
        super();
        this.updateLabels();
        selectTranslate(this._transloco, () => this.updateLabels(), this._destroyRef);
    }

    updateLabels(): void {
        this.openCalendarLabel = translate('COMMON_UI.DATE_PICKER.OPEN_CALENDAR');
        this.closeCalendarLabel = translate('COMMON_UI.DATE_PICKER.CLOSE_CALENDAR');
        this.prevMonthLabel = translate('COMMON_UI.DATE_PICKER.PREVIOUS_MONTH');
        this.nextMonthLabel = translate('COMMON_UI.DATE_PICKER.NEXT_MONTH');
        this.prevYearLabel = translate('COMMON_UI.DATE_PICKER.PREVIOUS_YEAR');
        this.nextYearLabel = translate('COMMON_UI.DATE_PICKER.NEXT_YEAR');
        this.changes.next();
    }
}
